import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import TableFieldMeta from '../../common/TableFieldMeta';
import VerbModifier from '../user/VerbModifier';
import EnumListerModifierDataTable from '../common/table/EnumListerModifierDataTable';


function UserPermissionRow(props) {
  const {
    permission,
    onUpdateRecord,
  } = props;
  const [members] = React.useState({
    permission,
  });

  return (
    <Grid container justify="space-around" key={permission.resource}>
      <Grid item>
        <VerbModifier
          resource={permission.resource}
          verb={permission.verb}
          onSetVerb={(resource, newVerb) => {
            members.permission.verb = newVerb;
            onUpdateRecord && onUpdateRecord(members.permission);
          }}
        />
      </Grid>
    </Grid>
  );
}

export default function UserPermissions(props) {
  const {
    permissions,
    onSetPermissions,
    title,
  } = props;

  const [members] = React.useState({
    permissions,
  });

  const updateRecords = (n) => {
    const idx = members.permissions.findIndex(e => e.resource === n.resource);
    if (idx === -1) members.permissions.push(n);
    else members.permissions[idx] = n;

    const filtered = members.permissions.filter(e => e.verb !== null);
    onSetPermissions && onSetPermissions(filtered);
  };

  return (
    <EnumListerModifierDataTable
      enumType="Resource"
      title={title}
      keyFinder={(record, metaKey) => record.resource === metaKey}
      keyInitiator={metaKey => ({
        resource: metaKey,
        verb: null,
      })}
      columnMeta={[
        TableFieldMeta.field('resource', 'Resource'),
        // TableFieldMeta.enum('Resource', '', node => node.resource),
        TableFieldMeta.fieldCell('verb', 'Access', node => (
          <UserPermissionRow
            key={node.value.resource}
            permission={node.value}
            onUpdateRecord={updateRecords}
          />
        ), { align: 'center' }),
      ]}
      dataNodes={members.permissions}
    />

  );
}

UserPermissions.propTypes = {
  permissions: PropTypes.array.isRequired,
  title: PropTypes.array,
};

UserPermissions.defaultProps = {
  title: null,
};
